


















import { Component, Vue } from 'vue-property-decorator';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import CONFIG from '@/common/config';

@Component
export default class OneClickFooter extends Vue {
  activityType: string = getActivityType();
  getUrlParam: Function = getUrlParam;

  getActivityType: Function = getActivityType;

  handleOneClickProduction(): void {
    const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
    const type: string = getUrlParam('type') as string;
    const id: string = getUrlParam('id') as string;
    const instId: string = getUrlParam('instId') as string;
    let url = '';
    if (env === 'prod') {
      url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
    } else {
      url = (CONFIG.showUrl as any)[env];
    }
    const showUrl: string = url + this.activityType + '/edit';
    window.location.href = `${showUrl}/?type=edit&instId=${instId}&id=${id}`;
  }
}
